import { useState, useEffect } from "react"

/**
 * Fetches glossary terms when the domain lens is active.
 * Returns an empty array for other lenses.
 */
export default function useGlossaryTerms(activeLens) {
  const [glossaryTerms, setGlossaryTerms] = useState([])

  useEffect(() => {
    if (activeLens !== "domain") return

    let cancelled = false

    const load = async () => {
      try {
        const res = await fetch("/glossary/terms.json")
        if (!res.ok) return
        const data = await res.json()
        if (!cancelled) setGlossaryTerms(data.terms || [])
      } catch (_) {
        // ignore
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [activeLens])

  return glossaryTerms
}
